import { CinemarkLink } from '@/components/cinemark-link/cinemark-link';
import { FacebookIcon } from '@/components/icons/facebook-icon';
import { InstagramIcon } from '@/components/icons/instagram-icon';
import { XdotcomIcon } from '@/components/icons/xdotcom-icon';
import { YoutubeIcon } from '@/components/icons/youtube-icon';
import { AnalyticsPageCategories } from '@/enums/analytics-type';

export const SocialShareLinks = (): React.JSX.Element => {
  return (
    <ul aria-label="Social Media Links"
      className="flex content-center gap-5"
    >
      <li>
        <CinemarkLink aria-label="Cinemark on Facebook"
          dataLinkCategory={AnalyticsPageCategories.FOOTER}
          dataLinkName="Facebook"
          dataTest="footer-social-share-facebook"
          href="http://www.facebook.com/cinemark"
          target="_blank"
        >
          <FacebookIcon aria-label="Facebook icon"
            className="icon icon-default icon-social-share"
            role="img"
          />
        </CinemarkLink>
      </li>
      <li>
        <CinemarkLink aria-label="Cinemark on X"
          dataLinkCategory={AnalyticsPageCategories.FOOTER}
          dataLinkName="X"
          dataTest="footer-social-share-x"
          href="http://x.com/cinemark"
          target="_blank"
        >
          <XdotcomIcon aria-label="X icon"
            className="icon icon-default icon-social-share"
            role="img"
          />
        </CinemarkLink>
      </li>
      <li>
        <CinemarkLink aria-label="Cinemark on YouTube"
          dataLinkCategory={AnalyticsPageCategories.FOOTER}
          dataLinkName="YouTube"
          dataTest="footer-social-share-youtube"
          href="http://www.youtube.com/cinemark"
          target="_blank"
        >
          <YoutubeIcon aria-label="Youtube icon"
            className="icon icon-default icon-social-share"
            role="img"
          />
        </CinemarkLink>
      </li>
      <li>
        <CinemarkLink aria-label="Cinemark on Instagram"
          dataLinkCategory={AnalyticsPageCategories.FOOTER}
          dataLinkName="Instagram"
          dataTest="footer-social-share-instagram"
          href="http://instagram.com/cinemark/"
          target="_blank"
        >
          <InstagramIcon aria-label="Instagram icon"
            className="icon icon-default icon-social-share"
            role="img"
          />
        </CinemarkLink>
      </li>
    </ul>
  );
};
